module.exports = __webpack_public_path__ + "static/img/Sign_In.fe012ea.jpg";